/** Human labels for normalized check_source prefix (before ':'). */
export const CHECK_PAYMENT_SOURCE_LABELS: Record<string, string> = {
  donations: 'Donations',
  chapter_supplies: 'Chapter supplies',
  elf_loans: 'ELF loans',
  '(unknown)': 'Unknown',
};

/** Matches backend: prefix before first ':', or full trimmed string. */
export function checkPaymentSourceBucket(checkSource?: string): string {
  const s = (checkSource ?? '').trim();
  if (!s) return '(unknown)';
  const i = s.indexOf(':');
  const bucket = i === -1 ? s : s.slice(0, i).trim();
  return bucket || '(unknown)';
}

export function checkPaymentSourceLabel(bucket: string): string {
  return CHECK_PAYMENT_SOURCE_LABELS[bucket] ?? bucket;
}

export interface CheckPaymentRelatedLink {
  href: string;
  label: string;
}

export function getCheckPaymentRelatedLink(check: {
  check_source?: string;
  source_id?: string;
}): CheckPaymentRelatedLink | null {
  const id = check.source_id?.trim();
  if (!id) return null;

  const bucket = checkPaymentSourceBucket(check.check_source);
  switch (bucket) {
    case 'donations':
      return { href: `/internal/donations/${id}`, label: 'View donation' };
    case 'chapter_supplies':
      return {
        href: `/chapter-supplies-management/orders/${id}`,
        label: 'View order',
      };
    default:
      return null;
  }
}
